import Vue from 'vue'
import qs from 'query-string'
import { isOver } from 'utils/general'

Vue.component('account-forms', {
  props: {
    view: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      activeForm: 'login',
      fromCheckout: false
    }
  },
  mounted () {
    this.fromCheckout = new URLSearchParams(location.search).has('checkout_url')

    this.convertUrlIDtoQueryString()

    if (location.search) {
      const parsedSearch = qs.parse(location.search)
      this.changeForm(parsedSearch.form)
    } else {
      this.changeFormStatic(this.view)
    }
  },
  computed: {
    isDesktop () {
      return isOver(767)
    },
    showTopLinks () {
      return (this.activeForm === 'login' || this.activeForm === 'register' || this.activeForm === 'recover') && window.innerWidth <= 767
    }
  },
  methods: {
    changeLinksActive (event) {
      this.changeForm(event.target.dataset.formType)
    },
    convertUrlIDtoQueryString () {
      if (~location.href.indexOf('#recover')) {
        history.replaceState(null, null, `${location.pathname}?form=recover`)
      }
    },
    changeFormStatic (form) {
      this.activeForm = form
    },
    changeForm (form = false) {
      const parsed = qs.parse(location.search)
      if (!form && !parsed.form) {
        return
      }
      if (!form) {
        form = parsed.form
      } else {
        parsed.form = form
      }
      this.activeForm = form
      history.replaceState(null, null, `${location.pathname}?${qs.stringify(parsed)}`)
    }
  }
})
